export default "__VITE_ASSET__DxitKm5U__"